import React from "react";

interface SummaryCardsProps {
  activeCount: number;
  flaggedCount: number;
  totalViolations: number;
}

const cardStyle = (bgColor: string): React.CSSProperties => ({
  flex: "1 1 200px",
  padding: "16px 20px",
  borderRadius: 8,
  background: bgColor,
  color: "var(--text-on-brand)",
  minWidth: 180,
});

const labelStyle: React.CSSProperties = {
  fontSize: 12,
  fontWeight: 500,
  opacity: 0.9,
  marginBottom: 4,
  textTransform: "uppercase",
  letterSpacing: "0.5px",
};

const valueStyle: React.CSSProperties = {
  fontSize: 28,
  fontWeight: 700,
  lineHeight: 1.2,
};

const SummaryCards: React.FC<SummaryCardsProps> = ({
  activeCount,
  flaggedCount,
  totalViolations,
}) => {
  return (
    <div style={{ display: "flex", gap: 16, flexWrap: "wrap", marginBottom: 20 }}>
      <div style={cardStyle("#2563eb")}>
        <div style={labelStyle}>Active Sessions</div>
        <div style={valueStyle}>{activeCount}</div>
      </div>
      <div style={cardStyle("#dc2626")}>
        <div style={labelStyle}>Flagged Students</div>
        <div style={valueStyle}>{flaggedCount}</div>
      </div>
      <div style={cardStyle("#d97706")}>
        <div style={labelStyle}>Total Violations</div>
        <div style={valueStyle}>{totalViolations}</div>
      </div>
    </div>
  );
};

export default SummaryCards;
